import { 
    Header, Link
  } from "@cloudscape-design/components";

export default () => {
    return (
        <>
            {/* //change the following header to be application-specific */}
            <Header variant="h1">
                Healthcare Life Science Search Demo
            </Header>
            <div className="sub-header">
            A common use case for using graph ontologies alongside Vector Similarity Search (VSS) is to be able give "explainability to vector searches".
                Using <Link href="https://pubmed.ncbi.nlm.nih.gov/" target="_blank">PubMed</Link> data, you can see how extensible combining VSS with graph models is over native text searching alone.
            </div>
        </>
    )
}